import { mdiInformationOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';

interface TipProps {
  children?: React.ReactNode;
  trigger?: React.ReactNode;
}

/**
 * Renders a "i" icon which shows a tooltip on hover. Pass `trigger` to show
 * the tooltip on a different element instead of the default icon.
 */
export const Tip: React.FC<TipProps> = ({ children, trigger }) => {
  const isDisabledTrigger =
    React.isValidElement<{ disabled?: boolean }>(trigger) && !!trigger.props.disabled;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {trigger ? (
          // The span carries pointer events for a disabled trigger (a disabled
          // element does not fire its own) and is focusable only in that case,
          // so an enabled trigger keeps a single tab stop.
          <span className="inline-flex" tabIndex={isDisabledTrigger ? 0 : undefined}>
            {trigger}
          </span>
        ) : (
          <span className="inline-flex cursor-help">
            <Icon path={mdiInformationOutline} size={0.75} />
          </span>
        )}
      </TooltipTrigger>
      <TooltipContent>{children}</TooltipContent>
    </Tooltip>
  );
};
